import { Outlet } from "react-router-dom";

const SafetyEducationManagementPageLayout = () => {
    return (
        <><Outlet /></>
    );
};

export default SafetyEducationManagementPageLayout;
